function getDefaultState() {
  return {
    isLoading: false,
    loadingTable: false,
    requisicoes: [],
    qtde_requisicoes: 0,
  };
}

const state = getDefaultState();

const getters = {
  getLoadingTable(state) {
    return state.loadingTable;
  },
  qtde_requisicoes(state) {
    return state.qtde_requisicoes;
  }
};

const mutations = {
  habilitarLoading(state, status) {
    state.isLoading = status;
  },
  habilitarLoadingTable(state, status) {
    state.loadingTable = status;
  },
  addRequisicao(state, requisicao) {
    state.requisicoes.push(requisicao);
  },
  resetRequisicoes(state) {
    state.requisicoes = []
  },
  incrementarQtdeRequisicoes(state) {
    state.qtde_requisicoes = state.qtde_requisicoes + 1;
  },
  decrementarQtdeRequisicoes(state) {
    state.qtde_requisicoes = Math.max(state.qtde_requisicoes - 1, 0);
  },
  resetarQtdeRequisicoes(state) {
    state.qtde_requisicoes = 0;
  },
};

const actions = {
  habilitarLoading: ({ commit }, status) => {
    commit('habilitarLoading', status);
  },
  habilitarLoadingTable: ({ commit }, status) => {
    commit('habilitarLoadingTable', status);
  },
  addRequisicao: ({ commit }, requisicao) => {
    commit('addRequisicao', requisicao);
  },
  resetRequisicoes: ({ commit }) => {
    commit('resetRequisicoes');
  },
  incrementarQtdeRequisicoes: ({ commit }) => {
    commit('incrementarQtdeRequisicoes');
  },
  decrementarQtdeRequisicoes: ({ commit }) => {
    commit('decrementarQtdeRequisicoes');
  },
  resetarQtdeRequisicoes: ({ commit }) => {
    commit('resetarQtdeRequisicoes');
  }
};

export default { namespaced: true, state, mutations, getters, actions };
